module.exports = __webpack_public_path__ + "static/media/image_forgot_password.d5ef38e8.svg";